import axios from 'axios';

const getHeaders = (token: string | undefined) => {
  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
};

export interface CompanySettings {
  CompanyName: string;
  ContactEmail: string;
  CompanyAddress: string;
  CompanyAddressNr: string;
  CompanyZipCode: string;
  CompanyCity: string;
  EmailFromAddress: string;
  EmailFromName: string;
  AccountingProviderType: string;
  ExactOnlineClientId: string;
  ExactOnlineCallbackUrl: string;
  HasExactOnlineSecret: boolean;
  HasExactOnlineConnection: boolean;
}

export interface UpdateCompanySettingsRequest {
  CompanyName?: string;
  ContactEmail?: string;
  CompanyAddress?: string;
  CompanyAddressNr?: string;
  CompanyZipCode?: string;
  CompanyCity?: string;
  EmailFromAddress?: string;
  EmailFromName?: string;
}

export interface ConfigureAccountingRequest {
  ProviderType: string;
  ExactOnlineClientId?: string;
  ExactOnlineClientSecret?: string;
  ExactOnlineCallbackUrl?: string;
}

export async function getCompanySettings(token: string | undefined): Promise<CompanySettings> {
  const res = await axios.get('/api/CompanySettings', getHeaders(token));
  return res.data;
}

export async function updateCompanySettings(
  data: UpdateCompanySettingsRequest,
  token: string | undefined
): Promise<CompanySettings> {
  const res = await axios.put('/api/CompanySettings', data, getHeaders(token));
  return res.data;
}

export async function configureAccountingProvider(
  data: ConfigureAccountingRequest,
  token: string | undefined
) {
  const res = await axios.put('/api/CompanySettings/AccountingProvider', data, getHeaders(token));
  return res.data;
}

export async function removeAccountingProvider(token: string | undefined) {
  const res = await axios.delete('/api/CompanySettings/AccountingProvider', getHeaders(token));
  return res.data;
}

/**
 * Initiates the Exact Online OAuth flow.
 * Returns the login URL that the browser should be redirected to.
 */
export async function initiateExactOnlineOAuth(token: string | undefined): Promise<{ LoginUrl?: string; Message?: string }> {
  const res = await axios.get('/api/CompanySettings/OAuthInitiate', getHeaders(token));
  return res.data;
}
